import React from 'react';
import { connect } from 'react-redux';
import 'antd/dist/antd.css';
import { Col, Row, Card, Typography } from 'antd';
import PropTypes from 'prop-types';

const { Title } = Typography;

const TransactionInfo = ({ contract }) => {

  return (
    <Card>
      <Row>
        <Title level={3} ellipsis>
          Información de la transacción
        </Title>
      </Row>
      <Row>
        <Col sm={12}>
          <p><b>NRO DE ORDEN DE COMPRA</b></p>
          {contract.payment && contract.payment.buyOrder}
        </Col>
        <Col sm={12}>
          <p><b>ID DE SESIÓN</b></p>
          {contract.payment && contract.payment.transactionId}
        </Col>
        <Col sm={12}>
          <p><b>METODO DE PAGO</b></p>
          {contract.payment && contract.payment.paymentMethod}
        </Col>
        <Col sm={12}>
          <p><b>DIVISA</b></p>
          {contract.payment && contract.payment.currency}
        </Col>
        <Col sm={12}>
          <p><b>MONTO</b></p>
          {contract.payment && `$${contract.payment.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`}
        </Col>
        <Col sm={12}>
          <p><b>ESTADO</b></p>
          {contract.payment && contract.payment.state}
        </Col>
      </Row>
    </Card>
  );
};

TransactionInfo.propTypes = {
  contract: PropTypes.object.isRequired,
};

const data = (state) => ({
  contract: state.contract.contract,
});

export default connect(data, null)(TransactionInfo);